import initializeJsonFromLocalStorage from "../../../utils/storage/initialize-storage-utils";
import { getLinks } from "../../../../src/services/external-link-management/external-link-management.js";

const linksExternal = {
  state: {
    linksExternalData: initializeJsonFromLocalStorage("links-external"),
  },
  mutations: {
    setLinksExternalData(state, data) {
      state.linksExternalData = data; 
    },
    clear(state) {
      state.linksExternalData = null;
    },
  },
  actions: {
    requestLinksExternalData({ commit }) {
      return new Promise((resolve, reject) => {
        getLinks()
          .then((linksExternal) => {
            localStorage.setItem("links-external", JSON.stringify(linksExternal));
            commit("setLinksExternalData", linksExternal);
            resolve(linksExternal);
          })
          .catch((err) => {
            console.error("requestLogin error: ", err);
            reject(err);
          });
      });
    },
    setStoreLinksExternalData({ commit }, data) {
      localStorage.setItem("links-external", JSON.stringify(data));
      commit("setLinksExternalData", data);
    },
    clearlinksExternalData({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          localStorage.setItem("links-external", "");
          commit("clear");
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  getters: {
    getLinksExternalData: (state) => state.linksExternalData,
  },
};

export default linksExternal;
